// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: 'AIzaSyCUFOKyPla8jW1upKLsGdjF0FadO3VVnqM',
  authDomain: 'ff-dashboard-404703.firebaseapp.com',
  projectId: 'ff-dashboard-404703',
  storageBucket: 'ff-dashboard-404703.appspot.com',
  messagingSenderId: '424322459068',
  appId: '1:424322459068:web:15c55c9a5641a30e7b37b9',
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);